
<template>
    <div class="main_unit">
        <div class="store_login_unit">{{brandStoreName}}</div>
        <div class="top_unit">
        </div>
        <pulse-loader class="w-100 text-center" :loading="isInitLoading"></pulse-loader>
        <div v-show="!isInitLoading">
            <nav v-if="(planFilePath)">
                <div v-for="senni in senniLocationList" :key="senni.buttonName">
                    <td id="senniBtn">
                        <ul class="ul_tbl_buttan">
                            <li>
                                <router-link v-if="senni.topButtonNo == 1 || senni.topButtonNo == 4" :to="{ name: 'dailyCheckMenuSnapIndex', params: {branIdPath: brandId, menuId: senni.topButtonId}}" >
                                    {{senni.buttonName}}
                                </router-link>
                                <router-link v-else-if="senni.topButtonNo == 2" :to="{ name: 'cookingCheckInputSnap', params: {branIdPath: brandId, menuId: senni.topButtonId, subMenuId: senni.menuButtonId}}" >
                                    {{senni.buttonName}}
                                </router-link>
                                <router-link v-else-if="senni.topButtonNo == 3" :to="{ name: 'healthCheckSnapIndex', params: {menuId: senni.topButtonId}}" >
                                    {{senni.buttonName}}
                                </router-link>
                                <a v-else-if="senni.topButtonNo == 0" @click.prevent.stop="openModel" >{{senni.buttonName}}</a>
                            </li>
                        </ul>
                    </td>
                </div>

            </nav>
            <div class="mgl_24" v-if="!(planFilePath)" >
                <p class="lavel_error_font">衛生管理計画書が登録されていません。</p>
            </div>
            <div v-if="planFilePath" class="wd840" id="pdf">
                <div class="pdf-container ">
                    <canvas v-for="page in pages" :id="'canvas' + page" :key="page" class="planCanvas" oncontextmenu="return false;"
                            height="100%" width="100%" style="height: 100%; width: 100%;"></canvas>
                </div>
            </div>
        </div>
        <div class="overlay" v-show="showContent">
            <div>
                <div class="modal_box wd512">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p class="modal_header_tit">警告</p>
                        </div>
                    </div>
                    <div class="modal_content_tex">
                        <p>遷移先が無効なため、画面表示することができませんでした。<br />
                            設定内容をご確認ください。
                        </p>
                    </div>
                    <div class="btn_submit_box">
                        <div class="btn_submit">
                            <a href="#" @click.prevent.stop="closeModel">OK</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import PulseLoader from '@/app/components/PulseLoader.vue'
    import PDF from 'pdfjs-dist'
    import PDFJSWorker from '!!file-loader!pdfjs-dist/build/pdf.worker.min.js';
    PDF.GlobalWorkerOptions.workerSrc = PDFJSWorker;
    export default {
        name: "HygieneManagementPlan",
        components: {
            PulseLoader,
        },
        created() {
            this.isLoading = false;
            this.brandId = this.$store.getters['brand/id'];
            this.calc();
        },
        data: function () {
            return {
                isLoading:false,
                isInitLoading:true,
                planFilePath: '',
                brandId: '',
                pdfDoc: null,
                pages: 0,
                senniLocationList: [{
                    buttonName: "",
                    displayFlg: null,
                    menuButtonId: null,
                    topButtonId: null,
                    topButtonNo: null,
                    transitionPageNo: null,
                }],
                showContent: false
            }
        },
        computed: {
            brandPath: function () {
                return this.$store.getters['brand/path']
            },
            brandStoreName: function () {
                let brandName = this.$store.getters['brand/name']
                let storeName = this.$store.getters['store/name']

                if (brandName == null) {
                    brandName = ''
                }

                if (storeName == null) {
                    storeName = ''
                }

                return brandName + '・' + storeName
            },
        },
        methods: {
            async calc() {
                var currentTime = this.getCurrentTime();

                // 衛生管理計画書取得API /user/brand/{brandId}/hygiene_management_plan'
                await this.$axios
                    .get(this.$apiEndpoint + 'user/brand/' + this.brandId + '/hygiene_management_plan', {params: {datetime: currentTime }})
                    .then(response => {
                        this.planFilePath = response.data.planFilePath;
                        this.senniLocationList = response.data.transitionSetting;
                    })
                    .catch((err) => {
                        let error = {
                            button: {
                                path: {name: 'top', params: {brandPath: this.brandPath}}
                            }
                        };

                        if (err.customError) {
                            error = Object.assign(error, err.customError)
                        }
                        this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                    }).finally(() => this.isInitLoading = false);

                if(this.planFilePath){
                    this.loadFile(this.planFilePath);
                }
            },
            async loadFile (url) {
                this.isInitLoading = true;
                let loadingTask = PDF.getDocument(url);
                loadingTask.promise.then(pdf => {
                    this.pdfDoc = pdf;
                    this.pages = this.pdfDoc.numPages;
                    this.$nextTick(() => {
                        this.renderPage(1);
                    });
                }).catch(() => {
                    let error = {
                        button: {
                            path: {name: 'top', params: {brandPath: this.brandPath}}
                        },
                        'message': 'PFDファイルの描画に失敗しました。'
                    };

                    this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                }).finally(() => this.isInitLoading = false);
            },
            renderPage (num) {
                this.pdfDoc.getPage(num).then(page => {
                    // 描画処理
                    let canvas = document.getElementById("canvas" + num);
                    let viewport = page.getViewport({ scale: 0.5, });
                    let desiredWidth = canvas.parentElement.clientWidth;
                    let scale = desiredWidth / viewport.width;
                    let scaledViewport = page.getViewport({ scale: scale, });

                    let ctx = canvas.getContext('2d');
                    canvas.height = scaledViewport.height;
                    canvas.width = scaledViewport.width;

                    let renderContext = {
                        canvasContext: ctx,
                        viewport: scaledViewport
                    };
                    //PDFに複数のページがある場合、複数回レンダリングする
                    page.render(renderContext);
                    if (this.pages > num) {
                        this.renderPage(num + 1);
                    }
                });
            },
            getCurrentTime() {
                // 当日日付をyyyymmddhhmmssで返却
                var now = new Date();
                var res = now.getFullYear() +
                    this.padZero(now.getMonth() + 1) +
                    this.padZero(now.getDate()) +
                    this.padZero(now.getHours()) +
                    this.padZero(now.getMinutes()) +
                    this.padZero(now.getSeconds());
                return res;
            },
            padZero(num) {
                //先頭ゼロ付加
                var result;
                if (num < 10) {
                    result = "0" + num;
                } else {
                    result = "" + num;
                }
                return result;
            },
            openModel() {
              this.showContent = true;
            },
            closeModel() {
                this.showContent = false;
            },
        },
    }
</script>